import planodecontas from "@/modules/PlanoDeContas/pages/Index";
import relatorioDRE from "@/modules/PlanoDeContas/pages/RelatorioDRE";

export default [
  {
    name: "planodecontas",
    path: "/planodecontas",
    component: planodecontas,
    meta: { title: "Plano de Contas" },
  },
  {
    name: "relatoriodre",
    path: "/relatoriodre",
    component: relatorioDRE,
    meta: { title: "Relatório DRE" },
  },
];
